/**
 * Secure sanitization schema for markdown content
 * Removes dangerous elements while preserving safe formatting
 */
export const secureMarkdownSchema = {
  // Explicitly define ONLY safe elements - anything not listed will be removed
  tagNames: [
    // Safe text formatting
    "strong",
    "b",
    "em",
    "i",
    "u",
    "s",
    "del",
    "mark",
    // Safe structural elements
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "p",
    "br",
    "hr",
    "ul",
    "ol",
    "li",
    "blockquote",
    "code",
    "pre",
    // Safe tables
    "table",
    "thead",
    "tbody",
    "tr",
    "th",
    "td",
    // Safe links (href will be sanitized)
    "a",
    // Safe images (src will be sanitized)
    "img",
    // Basic container elements
    "div",
    "span",
    // Safe formatting
    "small",
    "sub",
    "sup",
    // Lists and definition lists
    "dl",
    "dt",
    "dd",
    // NOTE: script, style, iframe, object, embed, form, input, button, etc. are NOT in this list
  ],
  // Safe attributes only - NO event handlers allowed
  attributes: {
    "*": ["className", "class", "id"], // Basic styling only
    a: ["href", "title"], // NO onclick, onmouseover, etc.
    img: ["src", "alt", "title", "width", "height"], // NO onerror, onload, etc.
    blockquote: ["cite"],
    th: ["scope"],
    td: ["headers"],
    table: ["summary"],
    // NOTE: No event handlers (onclick, onerror, onload, etc.) are allowed anywhere
  },
  // Strict protocol filtering - ONLY safe protocols
  protocols: {
    href: ["http", "https", "mailto"], // NO javascript:, data:, etc.
    src: ["http", "https"], // NO javascript:, data:, etc.
    cite: ["http", "https"],
    longDesc: ["http", "https"],
  },
  // Proper element nesting requirements
  ancestors: {
    li: ["ol", "ul"],
    dt: ["dl"],
    dd: ["dl"],
    tr: ["table"],
    th: ["tr"],
    td: ["tr"],
    thead: ["table"],
    tbody: ["table"],
  },
  // Force removal of dangerous elements (not just contents)
  strip: [
    "script",
    "style",
    "iframe",
    "object",
    "embed",
    "applet",
    "form",
    "input",
    "button",
    "select",
    "textarea",
    "option",
    "link",
    "meta",
  ],
  // Remove dangerous prefixes
  clobberPrefix: "user-content-",
  clobber: ["name", "id"],
  // No required attributes that could be exploited
  required: {},
};

/**
 * Extra restrictive schema for user-generated content
 * Even more limited set of allowed elements
 */
export const restrictiveMarkdownSchema = {
  ...secureMarkdownSchema,
  tagNames: [
    // Only the most basic formatting
    "strong",
    "b",
    "em",
    "i",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "p",
    "br",
    "ul",
    "ol",
    "li",
    "blockquote",
    "code",
  ],
  attributes: {
    "*": [], // No attributes allowed for restrictive mode
  },
  protocols: {},
};
